module.exports = __webpack_public_path__ + "145f4548a1a73aecbbf4d3ef1e60648a.svg";